(() => {
  const controllers=new WeakMap();
  function mount(root){
    if(controllers.has(root))return;
    const club=root.querySelector('[data-club-story]');if(!club)return;
    const tabs=[...club.querySelectorAll('[data-club-tab]')],panels=[...club.querySelectorAll('[data-club-panel]')];
    const abort=new AbortController(),{signal}=abort;
    const select=index=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});panels.forEach((panel,i)=>panel.hidden=i!==index);};
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(index),{signal});
      tab.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
        select(next);tabs[next].focus({preventScroll:true});
      },{signal});
    });
    select(Math.max(0,tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true')));
    controllers.set(root,()=>{abort.abort();controllers.delete(root);});
  }
  const scan=()=>document.querySelectorAll('.shopify-section').forEach(mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>controllers.get(event.target)?.());
})();
